function normalizePostalCode(value) {
  return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}

function autoFormatPostal(input) {
  if (!input) return;
  var cleaned = normalizePostalCode(input.value);

  if (cleaned.length > 3) {
    input.value = cleaned.substring(0, 3) + ' ' + cleaned.substring(3, 6);
  } else {
    input.value = cleaned.substring(0, 3);
  }
}

function checkPostal() {
  var input = document.getElementById('postal');
  var result = document.getElementById('result');
  var module = document.getElementById('source-delivery-module');
  var status = document.getElementById('source-delivery-status');

  if (!input || !result) return;

  var raw = normalizePostalCode(input.value);
  var fsa = raw.substring(0, 3);

  function updateTopStatus(messageHtml) {
    if (!status) return;
    status.innerHTML = messageHtml;
  }

  function render(type, message) {
    var colors = {
      success: '#22c55e',
      neutral: '#facc15',
      error: '#ef4444'
    };

    result.innerHTML = '<span style="color:' + colors[type] + '; font-size:16px;">' + message + '</span>';

    if (module) {
      module.style.boxShadow = '0 0 0 4px rgba(255,255,255,0.06)';
      setTimeout(function () {
        module.style.boxShadow = 'none';
      }, 700);
    }
  }

  var isValidFSA = /^[A-Z]\d[A-Z]$/.test(raw);
  var isValidPostal = /^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(raw);

  if (!raw || (!isValidFSA && !isValidPostal)) {
    render('error', 'Enter a valid Canadian postal code');
    updateTopStatus('⚡ Check Delivery');
    return;
  }

  var edmontonFSAs = ['T5A','T5B','T5C','T5E','T5G','T5H','T5J','T5K','T5L','T5M','T5N','T5P','T5R','T5S','T5T','T5V','T5W','T5X','T5Y','T5Z','T6A','T6B','T6C','T6E','T6G','T6H','T6J','T6K','T6L','T6M','T6N','T6P','T6R','T6S','T6T','T6V','T6W','T6X'];
  var sherwoodParkFSAs = ['T8A','T8B','T8C','T8E','T8H'];
  var stAlbertFSAs = ['T8N'];
  var kelownaFSAs = ['V1P','V1V','V1W','V1X','V1Y','V1Z','V4T'];
  var grandePrairieFSAs = ['T8V','T8W'];

  if (edmontonFSAs.indexOf(fsa) !== -1) {
    render('success', '✅ Edmonton — under 2hr delivery available');
    updateTopStatus('⚡ Edmonton detected — 24/7 delivery available');
    return;
  }

  if (sherwoodParkFSAs.indexOf(fsa) !== -1) {
    render('success', '✅ Sherwood Park — same-day delivery available');
    updateTopStatus('⚡ Sherwood Park detected — delivery available today');
    return;
  }

  if (stAlbertFSAs.indexOf(fsa) !== -1) {
    render('success', '✅ St. Albert — same-day delivery available');
    updateTopStatus('⚡ St. Albert detected — delivery available today');
    return;
  }

  if (kelownaFSAs.indexOf(fsa) !== -1) {
    render('success', '✅ Kelowna — same-day delivery available');
    updateTopStatus('⚡ Kelowna detected — delivery available today');
    return;
  }

  if (grandePrairieFSAs.indexOf(fsa) !== -1) {
    render('success', '✅ Grande Prairie — same-day delivery available');
    updateTopStatus('⚡ Grande Prairie detected — delivery available today');
    return;
  }

  render('neutral', '⚠️ No same-day delivery — Canada-wide shipping available');
  updateTopStatus('⚡ Canada-wide discreet shipping available');
}
document.addEventListener('DOMContentLoaded', function () {
  var input = document.getElementById('postal');
  if (!input) return;

  input.addEventListener('input', function () {
    autoFormatPostal(input);
    if (input.value.replace(/\s/g, '').length >= 3) {
      checkPostal();
    } else {
      var result = document.getElementById('result');
      var status = document.getElementById('source-delivery-status');
      if (result) result.innerHTML = '';
      if (status) status.innerHTML = '⚡ Check Delivery';
    }
  });

  input.addEventListener('blur', function () {
    autoFormatPostal(input);
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      checkPostal();
    }
  });
});